import { render, staticRenderFns } from "./payment-policy.vue?vue&type=template&id=2579dfff&scoped=true"
import script from "./payment-policy.vue?vue&type=script&lang=js"
export * from "./payment-policy.vue?vue&type=script&lang=js"
import style0 from "./payment-policy.vue?vue&type=style&index=0&id=2579dfff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579dfff",
  null
  
)

export default component.exports